<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-between">
    <div>
      <div class="bg-green-900 px-4 py-3 flex items-center justify-between shadow-md">
        <h1 class="text-white text-3xl font-bold">amazon</h1>
      </div>
      
      <div class="max-w-md mx-auto mt-8 px-4">
        <h1 class="text-2xl font-semibold mb-4 text-gray-800">Welcome</h1>
        
        <div class="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200 pb-6">
          <div class="flex items-center bg-gray-100 py-3 px-4 border-b border-gray-200">
            <input
              type="radio"
              class="w-5 h-5 text-green-600 focus:ring-green-500 mr-3"
              value="sign_up"
              v-model="selectedPAge"
              @change="redirectToPage"
              id="radio_sign_up"
            />
            <label for="radio_sign_up" class="font-semibold cursor-pointer text-gray-700">
              Create account <span class="font-normal text-sm text-gray-500 ml-1">New to Amazon?</span>
            </label>
          </div>
          
          <div class="flex items-center py-3 px-4 border-b border-gray-200">
            <input
              type="radio"
              class="w-5 h-5 text-green-600 focus:ring-green-500 mr-3"
              value="sign_in"
              v-model="selectedPAge"
              @change="redirectToPage"
              id="radio_sign_in"
            />
            <label for="radio_sign_in" class="font-semibold cursor-pointer text-gray-700">
              Sign in <span class="font-normal text-sm text-gray-500 ml-1">Already a customer?</span>
            </label>
          </div>
          
          <div class="px-6 pt-4">
            <div class="mb-4">
              <label class="block font-semibold mb-1 text-gray-700">Enter Email</label>
              <input
                type="text"
                class="border border-gray-300 rounded-md w-full h-11 px-3 focus:outline-none focus:border-green-600"
                v-model="ecommerceStore.email"
              />
            </div>
            
            <div class="mb-5">
              <label class="block font-semibold mb-1 text-gray-700">Enter Password</label>
              <input
                type="password"
                class="border border-gray-300 rounded-md w-full h-11 px-3 focus:outline-none focus:border-green-600"
                v-model="ecommerceStore.password"
              />
            </div>
            
            <div class="text-center">
              <button
                :disabled="isLoading"
                class="bg-yellow-400 hover:bg-yellow-500 disabled:opacity-50 text-gray-900 font-semibold w-full py-3 rounded-md shadow-sm transition-all duration-150 flex items-center justify-center gap-2"
                @click="handleSignIn"
              >
                <span v-if="isLoading" class="animate-spin inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full"></span>
                <span>{{ isLoading ? 'Logging in...' : 'Continue' }}</span>
              </button>
            </div>
            
            <div class="mt-4 text-xs text-gray-600 font-medium">
              By continuing you agree to Amazon's
              <a href="" class="underline text-blue-700 hover:text-blue-800">
                Conditions of Use
              </a>
              and
              <a href="" class="underline text-blue-700 hover:text-blue-800">
                Privacy Notice.
              </a>
            </div>
            
            <div class="font-semibold mt-6 border-b border-gray-200 pb-4 text-sm">
              <a href="" class="text-blue-700 hover:text-blue-800 hover:underline">Need help?</a>
            </div>
            
            <div class="mt-4">
              <p class="text-sm font-semibold mb-1 text-gray-700">Buying for work?</p>
              <a href="" class="text-blue-700 hover:text-blue-800 hover:underline text-sm font-semibold">
                Shop on Amazon Business
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="bg-gray-900 text-white pt-10 pb-10 mt-10">
      <div class="max-w-md mx-auto px-4">
        <div class="flex justify-between text-sm flex-wrap gap-4 border-b border-gray-800 pb-6 mb-6">
          <div class="hover:underline cursor-pointer"><i class="fa-solid fa-globe mr-1"></i> English</div>
          <div class="hover:underline cursor-pointer">$ USD - US. Dollar</div>
          <div class="hover:underline cursor-pointer flex items-center gap-1">
            <img src="/united.jpg" alt="" class="w-6 h-4 object-cover" /> United States
          </div>
        </div>
        
        <div class="flex justify-between text-xs text-gray-400 flex-wrap gap-3 mb-6">
          <a href="" class="hover:underline">Conditions of Use</a>
          <a href="" class="hover:underline">Privacy Notice</a>
          <a href="" class="hover:underline">Consumer Health Data Privacy Disclosure</a>
        </div>
        
        <div class="text-center text-xs text-gray-400 mb-2">
          Your Ads Privacy Choices <input type="checkbox" class="ml-1 align-middle" />
        </div>
        <div class="text-center text-xs text-gray-500">
          &copy;1996-2026, Amazon.com, Inc. or its affiliates
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useEcommerceStore } from "@/stores/Ecommerce";
import axios from "axios";
export default {
  data() {
    return {
      selectedPAge: "sign_in",
      ecommerceStore: "",
      isLoading: false,
    };
  },
  mounted() {
    const token = localStorage.getItem("token");
    if (token) {
      axios.defaults.withCredentials = true;
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    this.loginUser();
  },
  methods: {
    redirectToPage() {
      if (this.selectedPAge === "sign_in") {
        this.$router.push("/Signin");
      } else if (this.selectedPAge === "sign_up") {
        this.$router.push("/Signup");
      }
    },
    loginUser() {
      this.ecommerceStore = useEcommerceStore();
    },
    async handleSignIn() {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        await this.ecommerceStore.handleLogin();
        if (localStorage.getItem('signin') === 'true') {
          this.$router.push("/");
        } else {
          this.isLoading = false;
        }
      } catch (err) {
        console.error(err);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>